// extracted by mini-css-extract-plugin
export default {"authenticate":"_2aZ98"};